export class DescriptorRegistry {
  /**
   * @param {Array} factTables
   * @param {Array} dimensionTables
   * @param {Object} descriptorMap
   */
  constructor(factTables, dimensionTables, descriptorMap) {
    this.factTables = factTables
    this.dimensionTables = dimensionTables
    this._descriptorMap = descriptorMap
  }
  getDescriptor(id) {
    return this._descriptorMap[id]
  }
}
